import { render, staticRenderFns } from "./Admins.vue?vue&type=template&id=5033ee45&scoped=true&"
import script from "./Admins.vue?vue&type=script&lang=js&"
export * from "./Admins.vue?vue&type=script&lang=js&"
import style0 from "./Admins.vue?vue&type=style&index=0&id=5033ee45&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5033ee45",
  null
  
)

export default component.exports